import { render, staticRenderFns } from "./area-pipe.vue?vue&type=template&id=72c544fd&scoped=true"
import script from "./area-pipe.vue?vue&type=script&lang=js"
export * from "./area-pipe.vue?vue&type=script&lang=js"
import style0 from "./area-pipe.vue?vue&type=style&index=0&id=72c544fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c544fd",
  null
  
)

export default component.exports